module.exports = __webpack_public_path__ + "static/img/cinemaBottom2.bb1ee4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaBottom2.png
// module id = jzeE
// module chunks = 2